import {useContext, useState} from "react";
import {WorksitesNotesWithIdSchema} from "../../../types";
import {useIntl} from "react-intl";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import useAsyncError from "@hooks/useAsyncError";
import {NotificationsContext} from "@ui-components/Notifications";

export const useWorksiteNotes = () => {

  // context
  const {push} = useContext(NotificationsContext);

  // hooks
  const intl = useIntl();
  const apiRequest = useCountryAxiosInstance();
  const throwError = useAsyncError();

  // state
  const [loading, setLoading] = useState(false);

  // utilities
  const fetch = async (wid: number) => {
    setLoading(true);
    try {
      const params = {cod_worksite: wid};
      return await apiRequest!.get("/worksites_notes/all", {params}) as WorksitesNotesWithIdSchema[];
    }
    catch (e) {
      push({type: "error", title: intl.formatMessage({id: "server_error"}), message: "GET_WORKSITE_NOTES"});
      throwError(e);
    }
    finally {
      setLoading(false);
    }
  };

  return {fetch, loading};
}